import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { login } from '../services/authService';
import '../styles/login.css';

const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);

  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  useEffect(() => {
    setIsFormValid(email.trim() !== '' && password.trim() !== '');
  }, [email, password]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: 'YOUR_GOOGLE_CLIENT_ID',
        callback: handleGoogleSignIn,
      });
      window.google.accounts.id.renderButton(
        document.getElementById('google-signin-button'),
        { theme: 'outline', size: 'large' }
      );
    };
    document.body.appendChild(script);
  }, []);

  const handleGoogleSignIn = (response) => {
    console.log('Google Sign-In Response:', response);
    // TODO: handle token
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      const data = await login(email, password);
      authLogin(data.token);
      navigate('/dashboard');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="signin-wrapper">
      <div className="signin-background">
        <img src="/Vector8.png" alt="Slant" className="slant-img" />
        <div className="floating-icons">
          <img src="/instagram.png" alt="icon" className="icon i1" />
          <img src="/Image1.png" alt="icon" className="icon i2" />
          <img src="/Tiktok.png" alt="icon" className="icon i3" />
          <img src="/Image2.png" alt="icon" className="icon i4" />
          <img src="/Image3.png" alt="icon" className="icon i5" />
          <img src="/Image4.png" alt="icon" className="icon i6" />
          <img src="/Image4.png" alt="icon" className="icon i7" />
          <img src="/Tiktok.png" alt="icon" className="icon i8" />
          <img src="/Image5.png" alt="icon" className="icon i9" />
          <img src="/Image6.png" alt="icon" className="icon i10" />
          <img src="/Tiktok.png" alt="icon" className="icon i11" />
          <img src="/instagram.png" alt="icon" className="icon i12" />
          <img src="/Image7.png" alt="icon" className="icon i13" />
        </div>
      </div>

      <div className="signin-card">
        <div className="signin-header">
          <img src="/logo.png" alt="Logo" width={141} height={32}/>
          <h1 className='login-welcome'>Welcome Back 👋🏻</h1>
          <p className='login-webcome-text'>Please Sign in to continue</p>
        </div>

        <form className="signin-form" onSubmit={handleSignIn}>
          <label>
            <span>Email</span>
            <div className="input-container">
              <img src="/Group 99.png" className="input-icon" alt="Email Icon" />
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </label>

          <label>
            <span>Password</span>
            <div className="input-container">
              <img src="/Group 87.png" className="input-icon" alt="Lock Icon" />
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <img
                src={showPassword ? '/Group 34438.png' : '/Hide_24px.png'}
                alt="Toggle Visibility"
                className="toggle-icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </label>

          <button type="submit" disabled={!isFormValid} className={`signin-btn ${isFormValid ? '' : 'disabled'}`}>
            Sign In
          </button>
        </form>

        <div id="google-signin-button" className="google-signin" />

        <footer>ⓒ 2025 Social Jet, All Rights Reserved</footer>
      </div>
    </div>
  );
};

export default SignIn;
